export const en = {
  taskInfo: 'Task info',
  attachments: 'Attachments',
  comments: 'Comments',
  activity: 'Activity',
  integrations: 'Integrations',
  refresh: 'refresh'
};

export type Translations = typeof en;
